/**
 * Universal Variant Filter
 * Hides option values that don't have any valid variant combination
 * Works for any product with multiple options
 */

(function() {
  'use strict';

  class UniversalVariantFilter {
    constructor() {
      this.productData = null;
      this.variantMap = new Map();
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      const variantSelects = document.querySelector('variant-selects');
      if (!variantSelects) return;

      // Get product data
      this.getProductData();
      if (!this.productData || !this.productData.variants) return;

      console.log('Universal Variant Filter: Found', this.productData.variants.length, 'variants');

      // Build map of valid combinations
      this.buildVariantMap();

      // Listen for option changes
      variantSelects.addEventListener('change', (e) => {
        if (e.target.type === 'radio' || e.target.tagName === 'SELECT') {
          setTimeout(() => this.filterOptions(), 50);
        }
      });

      // Apply initial filter
      setTimeout(() => this.filterOptions(), 100);
    }

    getProductData() {
      // Try to get product data from window
      if (window.product && window.product.variants) {
        this.productData = window.product;
        return;
      }

      // Try to fetch from current URL
      const currentUrl = window.location.pathname;
      if (currentUrl.includes('/products/')) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', currentUrl + '.js', false); // Synchronous for simplicity
        xhr.send();
        if (xhr.status === 200) {
          this.productData = JSON.parse(xhr.responseText);
        }
      }
    }

    buildVariantMap() {
      // Build a map: option1Value -> Set of valid option2Values
      this.variantMap.clear();

      this.productData.variants.forEach(variant => {
        if (!variant.option1 || !variant.option2) return;

        if (!this.variantMap.has(variant.option1)) {
          this.variantMap.set(variant.option1, new Set());
        }
        this.variantMap.get(variant.option1).add(variant.option2);
      });

      console.log('Variant map built:', this.variantMap);
    }

    filterOptions() {
      const variantSelects = document.querySelector('variant-selects');
      if (!variantSelects) return;

      const optionGroups = variantSelects.querySelectorAll('.product-form__input');
      if (optionGroups.length < 2) return;

      // Get selected first option value
      const firstOption = optionGroups[0];
      const selectedValue = this.getSelectedValue(firstOption);

      if (!selectedValue) return;

      // Get valid second option values for this first option
      const validValues = this.variantMap.get(selectedValue);
      if (!validValues) return;

      console.log('Selected:', selectedValue, '-> Valid options:', Array.from(validValues));

      // Filter second option
      const secondOption = optionGroups[1];
      this.filterOptionGroup(secondOption, validValues);
    }

    getSelectedValue(optionGroup) {
      // Check for select dropdown
      const select = optionGroup.querySelector('select');
      if (select) return select.value;

      // Check for checked radio button
      const checked = optionGroup.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;

      return null;
    }

    filterOptionGroup(optionGroup, validValues) {
      // Handle select dropdown
      const select = optionGroup.querySelector('select');
      if (select) {
        Array.from(select.options).forEach(option => {
          if (option.value && !validValues.has(option.value)) {
            option.style.display = 'none';
          } else {
            option.style.display = '';
          }
        });
        return;
      }

      // Handle radio buttons (swatches or buttons)
      const inputs = optionGroup.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        const isValid = validValues.has(input.value);
        const label = input.nextElementSibling;

        if (!isValid) {
          // Hide invalid options with multiple approaches
          input.style.cssText = 'display: none !important; visibility: hidden !important; position: absolute !important; left: -9999px !important;';
          input.disabled = true;

          if (label && label.tagName === 'LABEL') {
            label.style.cssText = 'display: none !important; visibility: hidden !important; position: absolute !important; left: -9999px !important;';
          }

          console.log('Hiding:', input.value);
        } else {
          // Show valid options
          input.style.cssText = '';
          input.disabled = false;

          if (label && label.tagName === 'LABEL') {
            label.style.cssText = '';
          }

          console.log('Showing:', input.value);
        }
      });

      // Run filter again after a delay to catch any re-renders
      setTimeout(() => {
        inputs.forEach(input => {
          const isValid = validValues.has(input.value);
          if (!isValid && input.style.display !== 'none') {
            console.log('Re-hiding after delay:', input.value);
            input.style.cssText = 'display: none !important; visibility: hidden !important; position: absolute !important; left: -9999px !important;';
            const label = input.nextElementSibling;
            if (label && label.tagName === 'LABEL') {
              label.style.cssText = 'display: none !important; visibility: hidden !important; position: absolute !important; left: -9999px !important;';
            }
          }
        });
      }, 200);
    }
  }

  // Initialize
  new UniversalVariantFilter();
})();
